export const getFileExtensionFromMimeType = (mimeType) => {
  const mimeTypes = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "application/pdf": "pdf",
    "text/plain": "txt",
    "application/json": "json",
    // Add other MIME types as needed
  };

  return mimeTypes[mimeType] || "bin"; // Default to "bin" if MIME type is unknown
};
